import styled from 'styled-components'

import { FieldSkeleton } from '@/components/layout/field-row'

export const TypeIcon = styled.span<{ $color: string; $colorful: boolean }>(
  ({ theme, $color, $colorful }) => ({
    alignItems: 'center',
    backgroundColor: $colorful ? $color : theme.colors.gray200,
    borderRadius: theme.border.radius['8'],
    color: $colorful ? theme.colors.white : theme.colors.black700,
    display: 'flex',
    flexShrink: 0,
    // Note: smaller than the row's text block (title 2rem + subtitle 1.6rem + gap), so it never sets the row height
    height: '3.6rem',
    justifyContent: 'center',

    svg: {
      maxHeight: '2.2rem',
      maxWidth: '2.2rem',
    },
    width: '3.6rem',
  }),
)

export const HeaderActions = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['24'],
}))

// Note: stands in for the buildings count text in the subtitle
export const BuildingsTextSkeleton = styled(FieldSkeleton)(() => ({
  flexShrink: 0,
}))
